import { useState } from "react";
import { CloseIcon } from "../../../components/Icons";
import { useCandidateMutations } from "../../../hooks";

interface BulkCandidateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  termId: string | null;
  onCreated: () => void;
}

export function BulkCandidateDialog({
  open,
  onOpenChange,
  termId,
  onCreated,
}: BulkCandidateDialogProps) {
  const { bulkCreateCandidates } = useCandidateMutations();
  const [bulkText, setBulkText] = useState("");

  if (!open) return null;

  const handleBulkCreate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!termId) return;
    try {
      const lines = bulkText.split("\n").filter((line) => line.trim());
      const emails = lines
        .map((line) => line.trim())
        .filter((email) => email.includes("@"));

      if (emails.length === 0) {
        alert("有効なメールアドレスが見つかりません");
        return;
      }

      const result = await bulkCreateCandidates({ termId, emails });
      if (result) {
        if (result.unmatchedEmails.length > 0) {
          alert(
            `以下のメールアドレスに該当する従業員が見つかりません:\n${result.unmatchedEmails.join("\n")}`,
          );
        }
        setBulkText("");
        onOpenChange(false);
        onCreated();
        alert(`${result.createdCount}件の候補者を登録しました`);
      } else {
        alert("一括登録に失敗しました");
      }
    } catch {
      alert("一括登録に失敗しました");
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={() => onOpenChange(false)}
    >
      <div
        className="max-h-[90vh] w-[90%] max-w-[600px] overflow-auto rounded-xl bg-white p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-6 flex items-center justify-between">
          <h3 className="font-bold text-lg">候補者を一括登録</h3>
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            className="cursor-pointer border-none bg-none p-1"
          >
            <CloseIcon className="h-5 w-5" />
          </button>
        </div>
        <form onSubmit={handleBulkCreate} className="flex flex-col gap-4">
          <div>
            <label className="mb-1 block font-medium text-sm">
              メールアドレスを入力（1行に1つ）
            </label>
            <textarea
              value={bulkText}
              onChange={(e) => setBulkText(e.target.value)}
              placeholder={`例（1行に1件）:
yamada@example.com
sato@example.com
suzuki@example.com`}
              rows={10}
              required
              className="w-full resize-y rounded border border-[var(--color-border-default)] p-2 font-mono"
            />
            <p className="mt-1 text-[var(--color-text-secondary)] text-sm">
              ※従業員マスタに登録されているメールアドレスのみ登録可能です
            </p>
          </div>
          <button
            type="submit"
            className="cursor-pointer rounded-md border-none bg-[var(--color-primary-500)] px-4 py-2.5 font-medium text-sm text-white"
          >
            登録
          </button>
        </form>
      </div>
    </div>
  );
}
